export const CHECK_PALLETS = 'CHECK_PALLETS';
export const PALLET_COMMODITIES = 'PALLET_COMMODITIES';
